/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import cx from 'classnames'
import {
  createSpacingStyle,
  createAlignmentStyle,
  createFlexStyle,
} from 'helpers/styledHelpers'

const Wrapper = styled(
  ({ as: Elm, className, children }) => (
    <Elm className={cx('wrapper', className)}>
      {children}
    </Elm>
  ),
)`
  ${(props) => createSpacingStyle(props)}
  ${(props) => createAlignmentStyle(props)}
  ${(props) => createFlexStyle(props)}
  ${({ css }) => ({
    ...css,
  })}
`

Wrapper.propTypes = {
  as: PropTypes.string,
}
Wrapper.defaultProps = {
  as: 'div',
}
Wrapper.Panel = styled(Wrapper)`
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  overflow: hidden;
`
Wrapper.VerticalSeparator = ({
  elements,
  spacingTop,
  spacingBottom,
}) => (
  <div>
    {elements.map((element, i) => (
      <Wrapper
        key={i}
        {...(spacingTop && i === 0) && { mt: 1 }}
        {...(spacingBottom && i === elements.length - 1) && { mb: 1 }}
        {...(i > 0 && i < elements.length - 1) && { margin: '1rem 0' }}
      >
        {element}
      </Wrapper>
    ))}
  </div>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/components/wrappers/Wrapper.js